import * as React from 'react';
import { DashboardPage, ActionButton } from '../../Components';
import { MultiplePageState } from './Types'
import { SelectAction, ScanArea } from './Components';
import { EventHandlerProvider } from '../../../../Services/EventHandlerService';
import { NeedToCalibrateScannerWarningEvent, PackIdentifier, VeriLiteInformationEvent, VeriLiteWarningEvent, ActionCannotBeUndone, VeriLiteErrorEvent, MultiClearConfirm } from '../../../../Types';
import History from '../../../../Utils/History';
import { PackAction } from '../../Types';
import { MultiplePackRequestService } from '../../../../Services';
import { IAuthenticatedAppData } from '../../../../AuthenticatedApp/AuthenticatedApp';
import { scheme } from '../../../../Types/PackIdentifier';
import { MultipleQueue } from './Pages'
import { Switch, Route } from 'react-router-dom';

import { SafeRedirect } from '../../../../Components/SafeRedirect';
import { Alert } from 'reactstrap';

export interface IMultipleProps {
    applicationData: IAuthenticatedAppData;
}

interface IMultipleState{
    multiplePageStatus: MultiplePageState;
    selectedAction: PackAction;
    scannedPacks: PackIdentifier[];
    alert: string;
    clickDisabled: boolean;
}

export class Multiple extends React.Component<IMultipleProps, IMultipleState> {
    constructor(props: IMultipleProps) {
        super(props)

        if (this.props.applicationData.userInfo.UserRole.match(/SuperUser/g)) {
            History.push('/Dashboard/Reports');
        }

        if (this.props.applicationData.calibrationData == null) {
            EventHandlerProvider.GetInstance().AddEvent(NeedToCalibrateScannerWarningEvent(this.props.applicationData.resources));
            History.push('/Dashboard/Safe');
        }

        this.state = {
            multiplePageStatus: MultiplePageState.SelectAction,
            selectedAction: PackAction.None,
            scannedPacks: [],
            alert: "",
            clickDisabled: false
        }

        this.actions = null;
    }
    actions: any;

    componentDidUpdate(prevProps: IMultipleProps) {
        if ((prevProps.applicationData.selectedLocation != this.props.applicationData.selectedLocation && this.props.applicationData.calibrationData == null) || this.props.applicationData.locations.find((x: any) => { return x.Name == this.props.applicationData.selectedLocation; }).Type == "Pharmacist" ){
            History.push('/Dashboard/Safe');
        }
    }

    selectActionHandler = (action: PackAction) => {
        this.setState({
            multiplePageStatus: MultiplePageState.Scanning,
            selectedAction: action
        });
    } 

    submitBulkRequest = (showCheckPrompt: boolean) => {
        if (showCheckPrompt && (this.state.selectedAction.value == PackAction.MarkAsStolen.value || this.state.selectedAction.value == PackAction.MarkAsDestroyed.value)) {

            EventHandlerProvider.GetInstance().AddEvent(ActionCannotBeUndone(this.props.applicationData.resources, () => this.submitBulkRequest(false)));

            return;

        }

        MultiplePackRequestService.SubmitPackRequest(this.state.scannedPacks.map(packIdentifier => {
            return {
                ProductCodeScheme: scheme[packIdentifier.scheme],
                ProductCode: packIdentifier.productCode,
                SerialNumber: packIdentifier.serialNumber,
                BatchId: packIdentifier.batchIdentifier,
                ExpiryDate: packIdentifier.expiry} }), this.state.selectedAction, this.props.applicationData.selectedLocation)
            .then((result) => {
                
                if (result == "Done") {
                    this.setState({
                        multiplePageStatus: MultiplePageState.Done,
                        scannedPacks: [],
                        clickDisabled: false
                    });
                }
                else {
                    EventHandlerProvider.GetInstance().AddEvent(new VeriLiteErrorEvent(this.props.applicationData.resources.Error_RequestCouldNotBeSubmitted));
                }
        }).catch((err) => {
            console.error(err);
            this.setState({clickDisabled: false});            
        });
    }

    addPack = (pack: PackIdentifier) => {
        let scannedPacks = this.state.scannedPacks;
        if (this.props.applicationData.apiProvider == "Ssr" || scannedPacks.length == 0 || (scannedPacks[0].productCode == pack.productCode && scannedPacks[0].batchIdentifier == pack.batchIdentifier)) {
            scannedPacks.push(pack);
            this.setState({
                scannedPacks: scannedPacks,
                alert:""

            });
        } else {
            this.setState({ alert: this.props.applicationData.resources.Error_PacksMustBeSameProductAndBatch});
        }
        
    }

    setAlert = (key: string) => {
        this.setState({ alert: this.props.applicationData.resources[key] });
    }

    removePack = (pack: PackIdentifier) => {
        let scannedPacks = this.state.scannedPacks.filter(oldPack => oldPack.key() != pack.key());
        this.setState({
            scannedPacks: scannedPacks
        });
    }

    render() {
        return (
            <Switch>
                <Route exact path='/Dashboard/Multiple' render={() => <DashboardPage
                    content={
                        this.state.multiplePageStatus === MultiplePageState.Scanning ?
                            <div>
                                {this.state.alert && <Alert color="danger">
                                    {this.state.alert}
                                </Alert>}
                                <ScanArea maxNumberofPacks={this.props.applicationData.multipleMaxNumberofPacks} addPack={this.addPack} removePack={this.removePack} scannedPacks={this.state.scannedPacks} connectionState={this.props.applicationData.connectionState} calibrationData={this.props.applicationData.calibrationData} setAlert={this.setAlert} resources={this.props.applicationData.resources} />
                                </div>
                            :
                            <SelectAction availableActions={this.props.applicationData.availableActions} onChangeHandler={this.selectActionHandler} didSubmit={this.state.multiplePageStatus === MultiplePageState.Done} resources={this.props.applicationData.resources} />
                    }
                    actions={this.state.multiplePageStatus !== MultiplePageState.Scanning ? null :
                        <div>
                        <ActionButton
                            key={this.state.selectedAction.value}
                            action={this.state.selectedAction}
                            onClick={() => {
                                if (this.state.clickDisabled) return;
                                this.setState({ clickDisabled: true });
                                if (this.state.scannedPacks.length > 0) {
                                    this.submitBulkRequest(true);
                                }
                            }}
                            active
                                disabled={this.state.scannedPacks.length <= 0 || this.state.clickDisabled} />
                            <ActionButton
                                key="clear"
                                action={{ value: "clear", displayName: this.props.applicationData.resources.ClearScannedPacks}}
                                onClick={() => {
                                    if (this.state.scannedPacks.length > 0) {
                                        EventHandlerProvider.GetInstance().AddEvent(MultiClearConfirm(this.props.applicationData.resources, () => this.setState({ scannedPacks: [] })));                                        
                                    }
                                }}
                                active={false}
                                disabled={this.state.scannedPacks.length <= 0} />
                            </div>
                    }
                    placeholder={this.props.applicationData.resources.ActionsWillAppear_Multiple}
                    title={this.state.multiplePageStatus === MultiplePageState.Scanning ? null : this.props.applicationData.resources.SelectScanOption}
                    resources={this.props.applicationData.resources}
                />} />
                <Route exact path='/Dashboard/Multiple/Queue' render={() => <MultipleQueue applicationData={this.props.applicationData} />} />
                <Route path='/Dashboard/Multiple/*' render={() => <SafeRedirect to="/Dashboard/Multiple" resources={this.props.applicationData.resources} />} />
            </Switch>

            
        );
    }
}
